<p>management-dash works!</p>
<!-- <canvas baseChart
  [type]="'pie'"
  [datasets]="pieChartDatasets"
  [labels]="pieChartLabels"
  [options]="pieChartOptions"
  [plugins]="pieChartPlugins"
  [legend]="pieChartLegend">
</canvas> -->
